import { MAX_CHARACTER_INPUT_VALIDATION, MAX_EMAIL_INPUT_VALIDATION } from "@/constants/common";
import { validator } from "@/utils/validator";

// Allowed email domains for admin users
const ALLOWED_EMAIL_DOMAINS = ["iro-hana.com", "hopee.com.vn"];

export const adminUserSchema = validator.object().shape({
  fullName: validator.string().trim().emptyToNull().label("氏名").max(MAX_CHARACTER_INPUT_VALIDATION).required(),
  email: validator
    .string()
    .trim()
    .emptyToNull()
    .email()
    .max(MAX_EMAIL_INPUT_VALIDATION)
    .label("メールアドレス")
    .test("is-allowed-domain", `「メールアドレス」は${ALLOWED_EMAIL_DOMAINS.join("、")}のドメインのみ使用可能です。`, function (value) {
      if (!value) return true;
      const domain = value.split("@")[1]?.toLowerCase();
      return ALLOWED_EMAIL_DOMAINS.includes(domain);
    })
    .required(),
  adminRole: validator.string().isSelection().trim().emptyToNull().label("担当").required(),
  activeStatus: validator.string().trim().emptyToNull().label("ステータス").optional(),
});
